export default __webpack_public_path__ + "static/media/hodl-news.c8cd7ecc.PNG";